import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';

import {Color} from "@baseTypes/baseType";

import {useTypedSelector} from "@hooks/useTypedSelector";

import {noneEmpty} from "@utils/noneEmpty";
import {getColorByStatusUnits} from "@utils/getColorByStatusUnit";
import getListSelected from "@utils/getListSelected";

import {Service} from "@context/map/mutableStore";
import FieldService from "@context/map/fields/fieldsStore";

import MonitoringMenu from "@modules/card/menu/MonitoringMenu";

import TreeList from "@elements/treeList/TreeList";

import Container from "@elements/container/Container";

import st from './listFields.module.scss';
import LoadingBox from "@elements/loading/LoadingBox";
import { ApplicationContext } from "@pages/monitoring/map/MapPage";


const ListFields = (props: any) => {
  let ctx = useContext(ApplicationContext)
  let {
    isLoading
  }: any = useOutletContext()

  let {
    entities, ids, isApiLoading
  } = useTypedSelector(state => state.geoZones)
  
  const [currentFields, setCurrentFields] = useState({})
  let [nodes, setNode] = useState<any>([]);

  const service: any = useContext(Service);
  const navigate = useNavigate();
  
  // useEffect(() => {
  //   const {hashFields} = FieldService
  //   setCurrentFields(hashFields)
  // }, [data])
  
  
  let groupTemp = ({data}: any) => {
    let {name, glid} = data
    let title: string = name !== "." ? name : "Все"
    
    return (
      <div className={st.group}>
        {title}
      </div>
    )
  }
  
  let elementTemp = ({data}: any) => {
    let color = getColorByStatusUnits(data?.dynamicData?.unitState)
    return (
      <div className={st.field}>
        <div className={st.fieldStatus}>
          <div className={st.fieldPoint} style={{background: color}}/>
        </div>
        <div className={st.fieldDescription}>
          <div className={st.fieldName}>{data.glid} </div>
          <div className={st.fieldText}> {data.name}</div>
        </div>
      </div>
    )
  }
  
  let contextMenu = () => [
    {
      name: "Показать на карте",
      action: (params: any) => {
        let selected = getListSelected(params, "FIELDS")
        let list = selected.list.map((i: any) => i.glid);
        navigate(`${list.join(":")}/details`, {replace: true})
      }
    },
    {
      name: "Изменить геозону",
      action: (params: any) => {
        let selected = getListSelected(params, "FIELDS")
        let list = selected.list.map((i: any) => i.glid);
        navigate(`${list.join(":")}/edit`, {replace: true})
      }
    }
  ]
  useEffect(() => {
    setNode(Object.values(entities))
  }, [ids])

  if (isLoading) return <LoadingBox></LoadingBox>
  return (
    <Container
      blur={true}
      className={`${st.container} ${st.container__content}`}
      color={Color.White}
    >
      <MonitoringMenu/>
      
      <TreeList
        nodes={nodes}
        group={groupTemp}
        element={elementTemp}
        selected={ctx?.pixiContext?.state?.selectedGeoZones || []}
        contextMenu={contextMenu}
        className={st.content}
      />
    
    </Container>
  )
}
export default ListFields


// {
//   name: "Создать заметку",
//   action: (params: any) => "",
//   tooltip: "что-то паказать"
// },
// {
//   name: "Создать поручение",
//   action: (params: any) => ""
// },
// {
//   name: "-",
// },
// {
//   name: "Добавить групповой план",
//   action: (params: any) => ""
// }